import { PulseMapper } from '../mapper/PulseMapper';

export const pulseMapper = new PulseMapper();
